export default {
  broadcasts: []
};
